(function () {
    'use strict';

    let module = angular.module('doclr.pivot', ['doclr.pivot.api'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('pivot', {
                    url: '/pivot',
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.html',
                            resolve: {
                                pivotInfo: function (Pivot) {
                                    return Pivot.getData();
                                }
                            },
                            controller: function ($scope, pivotInfo, pivotTableService, Pivot, appContext) {
                                pivotTableService.setData(pivotInfo);
                                $scope.pivotTableService = pivotTableService;
                                $scope.appContext = appContext;
                                pivotTableService.setScope($scope);
                                $scope.refresh = function () {
                                    Pivot.getData()
                                        .then(data => pivotTableService.setData(data));
                                };
                            }
                        },
                        'content@pivot': {
                            templateUrl: '/partials/statistieken/pivot.html'
                        },
                        'sidebar@pivot': {
                            templateUrl: '/partials/statistieken/pivot.sidebar.html'
                        }
                    }

                });
        });

    module.factory('pivotTableService', ['notificationService', 'Pivot', 'excelDownloader', function (notificationService, Pivot, excelDownloader) {

        let state = {

            toonInstellingen: true,
            heeftData: false,
            heeftInstellingenGewijzigd: false,
            mode: 'Calendar',
            group: 'Day',
            type: 'Appointment',
            period: 'Custom',
            customFrom: moment().subtract(3, 'months').format('YYYY-MM-DD'),
            customTo: moment().format('YYYY-MM-DD'),
            exportFrom: moment().format('YYYY-MM-DD'),
            exportTo: moment().format('YYYY-MM-DD'),
            exportMinDate: moment().subtract(2, 'months').toDate(),
            exportLoading: false

        };

        let currentSettings;
        let translations;
        let currentData;
        let currentProductData;
        let allData;
        let allProductData;
        let pivotInfo;
        let parentScope;
        let dataClass = $.pivotUtilities.SubtotalPivotData;

        return {
            setData: setData,
            setScope: setScope,
            loadPivotTable: loadPivotTable,
            resetInstellingen: resetInstellingen,
            copyJsonToClipboard: copyJsonToClipboard,
            downloadExport: downloadExport,
            setPeriod: setPeriod,
            setGroup: setGroup,
            setType: setType,
            setMode: setMode,
            state: state,
            mydate: "2024-04-20"
        };

        function setData(newPivotInfo) {
            pivotInfo = newPivotInfo;
            loadTranslations();
            allData = createData(newPivotInfo.pivotData);
            allProductData = createData(newPivotInfo.pivotProductData);
            state.presets = createPresets(newPivotInfo);
            currentData = allData;
            currentProductData = allProductData;
            setPeriod();
        }

        function setScope($scope) {
            parentScope = $scope;
        }

        function downloadExport() {
            const minFrom = moment().subtract(2, 'months').startOf('day');
            if (moment(state.exportFrom, 'YYYY-MM-DD').isBefore(minFrom)) {
                notificationService.showError('De startdatum mag maximaal 2 maanden in het verleden liggen.');
                return;
            }
            state.exportLoading = true;
            Pivot.downloadAppointmentsExport(state.exportFrom, state.exportTo)
                .then((response) => {
                    excelDownloader.download(response, 'appointments-export-' + state.exportFrom + '_' + state.exportTo + '.xlsx');
                })
                .catch(() => {
                    notificationService.showError('De export kon niet worden geladen. Probeer het opnieuw.');
                })
                .finally(() => {
                    state.exportLoading = false;
                });
        }

        function setMode() {
            resetInstellingen("setMode");
        }

        function setPeriod() {
            filterData();
            loadPivotTable();
        }

        function setGroup(group) {
            state.group = group;
            resetInstellingen();
        }

        function setType(type) {
            state.type = type;
            resetInstellingen();
        }

        function createPresets(pivotInfo) {

            let presets = [
                {name: doclrVertaal.instant('pivot.preset.agenda.diagram'), value: 'Calendar'},
                {name: doclrVertaal.instant('pivot.preset.agenda.taart'), value: 'CalendarPie'},
                {name: doclrVertaal.instant('pivot.preset.afspraaktype.diagram'), value: 'Type'},
                {name: doclrVertaal.instant('pivot.preset.afspraaktype.taart'), value: 'TypePie'},
                {name: doclrVertaal.instant('pivot.preset.patient.praktijk.diagram'), value: 'PatPrak'},
                {name: doclrVertaal.instant('pivot.preset.patient.praktijk.taart'), value: 'PatPrakPie'},
                {name: doclrVertaal.instant('pivot.preset.weekdag.taart'), value: 'WeekdayPie'},
                {name: "Gebruiker diagram", value: 'UserDiagram'},
                {name: doclrVertaal.instant('pivot.preset.pivot'), value: 'Pivot'}
            ];

            pivotInfo.presets.forEach(x => {
                presets.push({name: x.name, value: x.nameId})
            });
            return presets;

        }

        function createSettings() {
            return {
                dataClass: dataClass,
                rows: currentSettings.rows,
                cols: currentSettings.cols,
                sorters: currentSettings.sorters,
                renderers: translations.renderers,
                rendererName: currentSettings.rendererName,
                exclusions: currentSettings.exclusions,
                hiddenAttributes: currentSettings.hiddenAttributes,
                hiddenFromDragDrop: currentSettings.hiddenFromDragDrop,
                rendererOptions: currentSettings.rendererOptions,
                onRefresh: function (config) {
                    if (hasConfigChanged(config)) {
                        currentSettings.rows = config.rows;
                        currentSettings.cols = config.cols;
                        currentSettings.rendererName = config.rendererName;
                        currentSettings.exclusions = config.exclusions;

                        state.heeftInstellingenGewijzigd = true;
                        parentScope.$applyAsync();
                    }
                }
            };
        }

        function hasConfigChanged(newConfig) {

            return !containsAll(currentSettings.cols, newConfig.cols) ||
                !containsAll(newConfig.cols, currentSettings.cols) ||
                !containsAll(currentSettings.rows, newConfig.rows) ||
                !containsAll(newConfig.rows, currentSettings.rows) ||
                currentSettings.rendererName !== newConfig.rendererName ||
                !isEmpty(newConfig.exclusions);
        }

        function containsAll(listA, listB) {
            for (let i = 0; i < listA.length; i++) {
                if (!listB.find(x => x === listA[i])) {
                    return false;
                }
            }
            return true;
        }

        function createDefaultSettings(origin) {

            let customPresets = pivotInfo.presets.filter(x => x.nameId === state.mode);

            if (customPresets.length > 0) {
                return loadCustomPreset(customPresets[0]);
            }


            if (state.mode === 'Pivot') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createPivotSettings();
            }

            if (state.mode === 'Type') {
                if (origin === 'setMode') {
                    state.type = 'Product';
                }
                return createTimeSeriesChartSettings(translations.pivot_header_type);
            }
            if (state.mode === 'TypePie') {
                if (origin === 'setMode') {
                    state.type = 'Product';
                }
                return createPieChartSettings(translations.pivot_header_type);
            }

            if (state.mode === 'Calendar') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createTimeSeriesChartSettings(translations.pivot_header_agenda);
            }

            if (state.mode === 'UserDiagram') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createTimeSeriesChartSettings(translations.pivot_header_creationUser);
            }

            if (state.mode === 'CalendarPie') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createPieChartSettings(translations.pivot_header_agenda);
            }

            if (state.mode === 'PatPrak') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createTimeSeriesChartSettings(translations.pivot_header_creationRole);
            }
            if (state.mode === 'PatPrakPie') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createPieChartSettings(translations.pivot_header_creationRole);
            }

            if (state.mode === 'WeekdayPie') {
                if (origin === 'setMode') {
                    state.type = 'Appointment';
                }
                return createPieChartSettings(translations.pivot_header_weekday);
            }

            return createTimeSeriesChartSettings(translations.pivot_header_status);
        }

        function loadCustomPreset(preset) {
            return {
                sorters: createSorters(),
                rows: preset.rows.map(row => translations[row]),
                cols: preset.columns.map(col => translations[col]),
                rendererName: translations.pivot_renderer_pivot,
                exclusions: {},
                hiddenAttributes: [],
                hiddenFromDragDrop: []
            };

        }

        function createPivotSettings() {
            return {
                sorters: createSorters(),
                rows: [translations.pivot_header_agenda],
                cols: [translations.pivot_header_type],
                rendererName: translations.pivot_renderer_pivot,
                exclusions: {},
                hiddenAttributes: [],
                hiddenFromDragDrop: []
            };
        }

        function createHiddenFields() {

            if (state.group === 'Week') {
                return [translations.pivot_header_dag, translations.pivot_header_month];
            }

            if (state.group === 'Month') {
                return [translations.pivot_header_dag, translations.pivot_header_week];
            }

            return [translations.pivot_header_week, translations.pivot_header_month];

        }

        function createSorters() {
            let sorters = {};
            sorters[translations.pivot_header_statustype] = $.pivotUtilities.sortAs([translations.pivot_statustype_normal, translations.pivot_statustype_negatief]);
            sorters[translations.pivot_header_status] = $.pivotUtilities.sortAs([
                'R',
                'B',
                'I',
                'A',
                'T',
                'E',
                'V',
                'D',

                'X',
                'N',
                'C'
            ]);

            return sorters;
        }

        function createTimeSeriesChartSettings(rowType) {
            return {
                sorters: createSorters(),
                rows: [rowType],
                cols: [createTimeSerieColumn()],
                rendererName: translations.pivot_renderer_bar,
                exclusions: {},
                hiddenAttributes: createHiddenFields(),
                hiddenFromDragDrop: createHiddenFields(),
                rendererOptions: {
                    plotly: {
                        hovermode: 'x unified',
                        colorway: [
                            "#5DA5DA", // blauw
                            "#F17C7E", // rood
                            "#FF9D5C", // oranje
                            "#60BD68", // groen
                            "#B276B2", // paars
                            "#9D9DA1", // grijs
                            "#8CD3DD", // teal / licht cyaan
                            "#F6C85F", // geel
                            "#A6D854", // lichtgroen
                            "#D4A6C8",  // roze/lila
                            "#2F6DAE", // blauw
                            "#E67E22", // oranje
                            "#2E8B57", // groen
                            "#C0392B", // rood
                            "#7D3C98", // paars
                            "#5D6D7E", // grijs
                            "#148F9E", // teal
                            "#D4AC0D", // geel
                            "#4F8F2F", // groen variant
                            "#A9326A"  // roze/paars
                        ],
                        paper_bgcolor: "#FFFFFF",
                        plot_bgcolor: "#FFFFFF",
                        hoverlabel: {namelength: -1},
                        font: {family: "system-ui, -apple-system, Segoe UI, Roboto, Arial", size: 12},
                        xaxis: {gridcolor: "#E9ECEF", zerolinecolor: "#E9ECEF", automargin: true},
                        yaxis: {gridcolor: "#E9ECEF", zerolinecolor: "#E9ECEF", automargin: true}
                    },
                    plotlyConfig: {
                        hovermode: 'x unified',
                        locale: doclrVertaal.getShortLanguageToUse(),
                    }
                }
            };
        }

        function createPieChartSettings(rowType) {
            return {
                sorters: createSorters(),
                rows: [rowType],
                cols: [],
                rendererName: translations.pivot_renderer_pie,
                exclusions: {},
                hiddenAttributes: createHiddenFields(),
                hiddenFromDragDrop: createHiddenFields(),
                rendererOptions: {
                    plotly: {
                        colorway: [
                            "#5DA5DA", // blauw
                            "#F17C7E", // rood
                            "#FF9D5C", // oranje
                            "#60BD68", // groen
                            "#B276B2", // paars
                            "#9D9DA1", // grijs
                            "#8CD3DD", // teal / licht cyaan
                            "#F6C85F", // geel
                            "#A6D854", // lichtgroen
                            "#D4A6C8",  // roze/lila
                            "#2F6DAE", // blauw
                            "#E67E22", // oranje
                            "#2E8B57", // groen
                            "#C0392B", // rood
                            "#7D3C98", // paars
                            "#5D6D7E", // grijs
                            "#148F9E", // teal
                            "#D4AC0D", // geel
                            "#4F8F2F", // groen variant
                            "#A9326A"  // roze/paars
                        ],
                        paper_bgcolor: "#FFFFFF",
                        plot_bgcolor: "#FFFFFF",
                        hoverlabel: {namelength: -1},
                        font: {family: "system-ui, -apple-system, Segoe UI, Roboto, Arial", size: 12},
                        xaxis: {gridcolor: "#E9ECEF", zerolinecolor: "#E9ECEF", automargin: true},
                        yaxis: {gridcolor: "#E9ECEF", zerolinecolor: "#E9ECEF", automargin: true}
                    },
                    plotlyConfig: {
                        locale: doclrVertaal.getShortLanguageToUse(),
                    }
                }
            };
        }

        function createTimeSerieColumn() {
            let serieType = translations.pivot_header_dag;

            if (state.group === 'Week') {
                serieType = translations.pivot_header_week;
            }

            if (state.group === 'Month') {
                serieType = translations.pivot_header_month;
            }

            return serieType;
        }

        function resetInstellingen(origin) {
            currentSettings = createDefaultSettings(origin);
            state.heeftInstellingenGewijzigd = false;
            loadPivotTable();
        }

        function loadPivotTable() {
            if (!currentSettings) {
                currentSettings = createDefaultSettings();
            }
            const data = state.type === 'Appointment' ? currentData : currentProductData;
            state.heeftData = data.length > 0;

            if (state.heeftData) {
                window.setTimeout(function () {
                    $('#output-agendastats')
                        .pivotUI(data, createSettings(currentSettings), true, doclrVertaal.getShortLanguageToUse());
                }, 200);
            }
        }

        function createData(data) {
            let events = [];
            for (let i = 0; i < data.length; i++) {
                events.push(maakPivotAfspraak(data[i]));
            }

            return events;
        }

        function maakPivotAfspraak(appointment) {
            let pivotAfspraak = {};
            let day = moment(appointment.day);
            pivotAfspraak[translations.pivot_header_type] = appointment.productName;
            //   pivotAfspraak[translations.pivot_header_status] = appointment.appointmentStatus;
            pivotAfspraak[translations.pivot_header_dag] = day.format('YYYY-MM-DD');
            pivotAfspraak[translations.pivot_header_week] = day.isoWeekYear() + ' ' + doclrVertaal.instant('pivot.value.week') + ' ' + day.isoWeek();
            pivotAfspraak[translations.pivot_header_weekday] = translations['pivot_weekday_' + day.isoWeekday()];
            pivotAfspraak[translations.pivot_header_month] = day.format('YYYY-MM');
            pivotAfspraak[translations.pivot_header_dag] = day.format('YYYY-MM-DD');
            pivotAfspraak[translations.pivot_header_uur] = appointment.from.substring(0, 2) + translations.uurAfkorting;
            pivotAfspraak[translations.pivot_header_duration] = appointment.duration;
            pivotAfspraak[translations.pivot_header_agenda] = appointment.calendar;
            pivotAfspraak[translations.pivot_header_isPresent] = appointment.isPresent ? translations.pivot_yes : translations.pivot_no;
            //  pivotAfspraak[translations.pivot_header_statustype] = translations['pivot_statustype_' + appointment.status];
            //  pivotAfspraak[translations.pivot_header_statustype] = translations['pivot_statustype_' + appointment.status];
            pivotAfspraak[translations.pivot_header_creationRole] = appointment.creationRole;
            pivotAfspraak[translations.pivot_header_creationUser] = appointment.creationUser;
            pivotAfspraak[translations.pivot_header_creationDate] = moment(appointment.createdOn).format('YYYY-MM-DD');
            //   pivotAfspraak[translations.pivot_header_statustype] = translations['pivot_statustype_' + appointment.status];
            pivotAfspraak[translations.pivot_header_aantal] = appointment.numberOfPersons;
            pivotAfspraak["Dienst"] = appointment.department;
            pivotAfspraak["Producten"] = appointment.numberOfProducts;

            for (let i = 0; i < pivotInfo.customDataInfo.length; i++) {
                let customData = pivotInfo.customDataInfo[i];
                pivotAfspraak[translations["pivot_header_" + customData.fieldId]] = appointment[customData.fieldId];
            }

            return pivotAfspraak;
        }

        function translateType(typeId) {
            let translation = translations['type_' + typeId];
            if (!translation) {
                translation = doclrVertaal.translateTypeById(typeId)
                translations['type_' + typeId] = translation;
            }

            return translation;
        }

        function loadTranslations() {
            const pivotStatustypeNormal = doclrVertaal.instant('pivot.statustype.normal');
            const pivotStatustypeNegative = doclrVertaal.instant('pivot.statustype.negatief');
            const renderers = {};
            renderers[doclrVertaal.instant('pivot.renderer.pivot')] = $.pivotUtilities.subtotal_renderers['Table With Subtotal'];
            renderers[doclrVertaal.instant('pivot.renderer.bar.chart')] = $.pivotUtilities.plotly_renderers['Bar Chart'];
            renderers[doclrVertaal.instant('pivot.renderer.stacked.bar.chart')] = $.pivotUtilities.plotly_renderers['Stacked Bar Chart'];
            renderers[doclrVertaal.instant('pivot.renderer.line.chart')] = $.pivotUtilities.plotly_renderers['Line Chart'];
            renderers[doclrVertaal.instant('pivot.renderer.area.chart')] = $.pivotUtilities.plotly_renderers['Area Chart'];
            renderers[doclrVertaal.instant('pivot.renderer.pie.chart')] = $.pivotUtilities.plotly_renderers['Multiple Pie Chart'];

            translations = {
                uurAfkorting: doclrVertaal.instant('pivot.uur.afkorting'),
                pivot_header_type: "Product",
                pivot_header_status: doclrVertaal.instant('pivot.header.status'),
                pivot_header_dag: doclrVertaal.instant('pivot.header.dag'),
                pivot_header_week: doclrVertaal.instant('pivot.header.week'),
                pivot_header_weekday: doclrVertaal.instant('pivot.header.weekday'),
                pivot_header_month: doclrVertaal.instant('pivot.header.month'),
                pivot_header_uur: doclrVertaal.instant('pivot.header.uur'),
                pivot_header_duration: doclrVertaal.instant('pivot.header.duration'),
                pivot_header_agenda: doclrVertaal.instant('pivot.header.agenda'),
                pivot_header_aantal: doclrVertaal.instant('pivot.header.aantal'),
                pivot_header_statustype: doclrVertaal.instant('pivot.header.statustype'),
                pivot_header_needsPayment: doclrVertaal.instant('pivot.header.needsPayment'),
                pivot_header_efom: doclrVertaal.instant('pivot.header.efom'),
                pivot_header_creationRole: doclrVertaal.instant('pivot.header.creationRole'),
                pivot_header_creationUser: "Gebruiker",
                pivot_header_creationDate: doclrVertaal.instant('pivot.header.creationDate'),
                pivot_header_isPresent: doclrVertaal.instant('pivot.header.isPresent'),
                pivot_statustype_normal: pivotStatustypeNormal,
                pivot_statustype_negatief: pivotStatustypeNegative,
                pivot_statustype_R: pivotStatustypeNormal,
                pivot_statustype_B: pivotStatustypeNormal,
                pivot_statustype_A: pivotStatustypeNormal,
                pivot_statustype_V: pivotStatustypeNormal,
                pivot_statustype_T: pivotStatustypeNormal,
                pivot_statustype_D: pivotStatustypeNormal,
                pivot_statustype_E: pivotStatustypeNormal,
                pivot_statustype_I: pivotStatustypeNormal,
                pivot_weekday_1: doclrVertaal.instant('day.monday'),
                pivot_weekday_2: doclrVertaal.instant('day.tuesday'),
                pivot_weekday_3: doclrVertaal.instant('day.wednesday'),
                pivot_weekday_4: doclrVertaal.instant('day.thursday'),
                pivot_weekday_5: doclrVertaal.instant('day.friday'),
                pivot_weekday_6: doclrVertaal.instant('day.saturday'),
                pivot_weekday_7: doclrVertaal.instant('day.sunday'),
                pivot_yes: doclrVertaal.instant('doclr.Yes'),
                pivot_no: doclrVertaal.instant('doclr.No'),

                pivot_statustype_X: pivotStatustypeNegative,
                pivot_statustype_C: pivotStatustypeNegative,
                pivot_statustype_N: pivotStatustypeNegative,
                renderers: renderers,
                pivot_renderer_pivot: doclrVertaal.instant('pivot.renderer.pivot'),
                pivot_renderer_pie: doclrVertaal.instant('pivot.renderer.pie.chart'),
                pivot_renderer_bar: doclrVertaal.instant('pivot.renderer.stacked.bar.chart')
            };

            for (let i = 0; i < pivotInfo.customDataInfo.length; i++) {
                let customData = pivotInfo.customDataInfo[i];
                translations["pivot_header_" + customData.fieldId] = customData.translation;
            }

            $.pivotUtilities.locales.nl.localeStrings.apply = 'Toepassen';
            $.pivotUtilities.locales.nl.localeStrings.cancel = 'Annuleren';
            $.pivotUtilities.locales.de.localeStrings.apply = 'Toepassen';
            $.pivotUtilities.locales.de.localeStrings.cancel = 'Bestätigen';
        }

        function isEmpty(obj) {
            for (const prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }

            return JSON.stringify(obj) === JSON.stringify({});
        }

        function copyJsonToClipboard() {
            let dataToCopy = state.type === "Appointment" ? currentData : currentProductData;

            let listOfObjects = dataToCopy.filter(x => {
                if (currentSettings.exclusions) {
                    for (const property in currentSettings.exclusions) {
                        if (currentSettings.exclusions[property].length > 0) {
                            for (let i = 0; i < currentSettings.exclusions[property].length; i++) {
                                if (x[property] === currentSettings.exclusions[property][i]) {
                                    return false;
                                }

                            }
                        }
                    }
                }
                return true;
            })
                .sort((p1, p2) => (p1[translations.pivot_header_dag] < p2[translations.pivot_header_dag]) ? -1 : (p1[translations.pivot_header_dag] > p2[translations.pivot_header_dag]) ? 1 : 0);

            const headers = [
                translations.pivot_header_dag,
                translations.pivot_header_agenda,
                translations.pivot_header_month,
                "Dienst",
                "Producten",
                translations.pivot_header_uur,
                translations.pivot_header_type,
                translations.pivot_header_duration,
                translations.pivot_header_aantal,
                translations.pivot_header_creationDate,
                translations.pivot_header_isPresent,
                translations.pivot_header_creationRole,
                translations.pivot_header_creationUser
            ];

            for (let i = 0; i < pivotInfo.customDataInfo.length; i++) {
                let customData = pivotInfo.customDataInfo[i];
                headers.push(translations["pivot_header_" + customData.fieldId]);
            }

            let csv = '', row, cell;

            for (cell = 0; cell < headers.length; cell++) {
                csv += (headers[cell] + '').replace(/[\n\t]+/g, ' ');
                if (cell + 1 < headers.length) {
                    csv += '\t';
                }
            }

            csv += '\n';

            for (row = 0; row < listOfObjects.length; row++) {
                for (cell = 0; cell < headers.length; cell++) {
                    csv += (listOfObjects[row][headers[cell]] + '').replace(/[\n\t]+/g, ' ');
                    if (cell + 1 < headers.length) {
                        csv += '\t';
                    }
                }
                if (row + 1 < listOfObjects.length) {
                    csv += '\n';
                }
            }
            copyTextToClipboard(csv);
        }

        function fallbackCopyTextToClipboard(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            if (successful) {
                notificationService.showSuccess(doclrVertaal.instant('pivot.kopieer.succes'));
            }
            document.body.removeChild(textArea);
        }

        function copyTextToClipboard(text) {
            if (!navigator.clipboard) {
                fallbackCopyTextToClipboard(text);
                return;
            }
            navigator.clipboard.writeText(text).then(function () {
                notificationService.showSuccess(doclrVertaal.instant('pivot.kopieer.succes'));
            });
        }

        function filterData() {

            if (state.period === 'All') {
                currentData = allData;
                currentProductData = allProductData;
                return;
            }

            let from;
            let to;

            if (state.period === 'Today') {
                from = moment().startOf('day');
                to = moment().startOf('day');
            }

            if (state.period === 'Yesterday') {
                from = moment().startOf('day').subtract(1, 'days');
                to = moment().startOf('day').subtract(1, 'days');
            }


            if (state.period === 'Tomorrow') {
                from = moment().startOf('day').add(1, 'days');
                to = moment().startOf('day').add(1, 'days');
            }

            if (state.period === 'ThisWeek') {
                from = moment().startOf('day').weekday(0);
                to = moment().startOf('day').weekday(6);
            }

            if (state.period === 'LastWeek') {
                from = moment().startOf('day').subtract(7, 'days').weekday(0);
                to = moment().startOf('day').subtract(7, 'days').weekday(6);
            }

            if (state.period === 'NextWeek') {
                from = moment().startOf('day').add(7, 'days').weekday(0);
                to = moment().startOf('day').add(7, 'days').weekday(6);
            }


            if (state.period === 'ThisMonth') {
                from = moment(moment().startOf('day').format('YYYY-MM-01'));
                to = moment(moment().startOf('day').format('YYYY-MM-' + moment().daysInMonth()));
            }

            if (state.period === 'NextMonth') {
                from = moment(moment().startOf('day').add(1, 'months').format('YYYY-MM-01'));
                to = moment(moment().startOf('day').add(1, 'months').format('YYYY-MM-' + moment().add(1, 'months').daysInMonth()));
            }

            if (state.period === 'LastMonth') {
                from = moment(moment().startOf('day').subtract(1, 'months').format('YYYY-MM-01'));
                to = moment(moment().startOf('day').subtract(1, 'months').format('YYYY-MM-' + moment().subtract(1, 'months').daysInMonth()));
            }

            if (state.period === 'ThisYear') {
                from = moment(moment().startOf('day').subtract(1, 'months').format('YYYY-01-01'));
                to = moment(moment().startOf('day').subtract(1, 'months').format('YYYY-12-31'));
            }

            if (state.period === 'Custom') {
                from = moment(state.customFrom).format('YYYY-MM-DD');
                to = moment(state.customTo).format('YYYY-MM-DD');
            }

            currentData = allData.filter(function (appointment) {
                let day = moment(appointment[translations.pivot_header_dag]);
                return day.isSame(from) || day.isSame(to) || day.isBetween(from, to);
            });

            currentProductData = allProductData.filter(function (appointment) {
                let day = moment(appointment[translations.pivot_header_dag]);
                return day.isSame(from) || day.isSame(to) || day.isBetween(from, to);
            });
        }
    }]);

    module.directive('doclrPivot', function () {
        return {
            restrict: 'E',
            templateUrl: '/partials/statistieken/pivot.component.html',
            replace: true,
            scope: {},
            controller: function ($scope, slicesService, pivotTableService) {
                $scope.pivotTableService = pivotTableService;
            }
        };
    });
})();